/**
 * Generated by orval v8.19.0 🍺
 * Do not edit manually.
 * Catalog Api
 * REST api
 * OpenAPI spec version: 0.0.1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetCollection200,
  GetCollectionAdmin200,
  GetCollectionAdminParams,
  GetCollectionParams,
  TagJsonldTagRead,
  TagJsonldTagWrite,
  TagTagWrite
} from './schemas';

import { apiCatalog } from '../../apiCatalog';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type get_collection_adminResponse200 = {
  data: GetCollectionAdmin200
  status: 200
}

export type get_collection_adminResponseSuccess = (get_collection_adminResponse200) & {
  headers: Headers;
};
;

export type get_collection_adminResponse = (get_collection_adminResponseSuccess)

export const getGetCollectionAdminUrl = (slug: string,
    params?: GetCollectionAdminParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["slug[]"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/api/admin/${slug}/tags?${stringifiedParams}` : `/api/api/admin/${slug}/tags`
}

/**
 * Retrieves the collection of Tag resources.
 * @summary Retrieves the collection of Tag resources.
 */
export const get_collection_admin = async (slug: string,
    params?: GetCollectionAdminParams, options?: RequestInit): Promise<get_collection_adminResponse> => {

  return apiCatalog<get_collection_adminResponse>(getGetCollectionAdminUrl(slug,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCollectionAdminQueryKey = (slug: string,
    params?: GetCollectionAdminParams,) => {
    return [
    `/api/api/admin/${slug}/tags`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetCollectionAdminQueryOptions = <TData = Awaited<ReturnType<typeof get_collection_admin>>, TError = unknown>(slug: string,
    params?: GetCollectionAdminParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get_collection_admin>>, TError, TData>>, request?: SecondParameter<typeof apiCatalog>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCollectionAdminQueryKey(slug,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof get_collection_admin>>> = ({ signal }) => get_collection_admin(slug,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: slug !== null && slug !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof get_collection_admin>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCollectionAdminQueryResult = NonNullable<Awaited<ReturnType<typeof get_collection_admin>>>
export type GetCollectionAdminQueryError = unknown


export function useGetCollectionAdmin<TData = Awaited<ReturnType<typeof get_collection_admin>>, TError = unknown>(
 slug: string,
    params: undefined |  GetCollectionAdminParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof get_collection_admin>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof get_collection_admin>>,
          TError,
          Awaited<ReturnType<typeof get_collection_admin>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCollectionAdmin<TData = Awaited<ReturnType<typeof get_collection_admin>>, TError = unknown>(
 slug: string,
    params?: GetCollectionAdminParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get_collection_admin>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof get_collection_admin>>,
          TError,
          Awaited<ReturnType<typeof get_collection_admin>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCollectionAdmin<TData = Awaited<ReturnType<typeof get_collection_admin>>, TError = unknown>(
 slug: string,
    params?: GetCollectionAdminParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get_collection_admin>>, TError, TData>>, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves the collection of Tag resources.
 */

export function useGetCollectionAdmin<TData = Awaited<ReturnType<typeof get_collection_admin>>, TError = unknown>(
 slug: string,
    params?: GetCollectionAdminParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get_collection_admin>>, TError, TData>>, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCollectionAdminQueryOptions(slug,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type tag_postResponse201 = {
  data: TagJsonldTagRead
  status: 201
}

export type tag_postResponse400 = {
  data: void
  status: 400
}

export type tag_postResponse422 = {
  data: void
  status: 422
}

export type tag_postResponseSuccess = (tag_postResponse201) & {
  headers: Headers;
};
export type tag_postResponseError = (tag_postResponse400 | tag_postResponse422) & {
  headers: Headers;
};

export type tag_postResponse = (tag_postResponseSuccess | tag_postResponseError)

export const getTagPostUrl = () => {




  return `/api/tag`
}

/**
 * Creates a Tag resource.
 * @summary Creates a Tag resource.
 */
export const tag_post = async (tagPostBody: TagJsonldTagWrite | TagTagWrite, options?: RequestInit): Promise<tag_postResponse> => {

  return apiCatalog<tag_postResponse>(getTagPostUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body: JSON.stringify(tagPostBody)
  }
);}





export const getTagPostMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tag_post>>, TError,{data: TagJsonldTagWrite | TagTagWrite}, TContext>, request?: SecondParameter<typeof apiCatalog>}
): UseMutationOptions<Awaited<ReturnType<typeof tag_post>>, TError,{data: TagJsonldTagWrite | TagTagWrite}, TContext> => {

const mutationKey = ['tagPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof tag_post>>, {data: TagJsonldTagWrite | TagTagWrite}> = (props) => {
          const {data} = props ?? {};

          return  tag_post(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TagPostMutationResult = NonNullable<Awaited<ReturnType<typeof tag_post>>>
    export type TagPostMutationBody = TagJsonldTagWrite | TagTagWrite
    export type TagPostMutationError = void

    /**
 * @summary Creates a Tag resource.
 */
export const useTagPost = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tag_post>>, TError,{data: TagJsonldTagWrite | TagTagWrite}, TContext>, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof tag_post>>,
        TError,
        {data: TagJsonldTagWrite | TagTagWrite},
        TContext
      > => {
      return useMutation(getTagPostMutationOptions(options), queryClient);
    }
    export type tag_deleteResponse204 = {
  data: void
  status: 204
}

export type tag_deleteResponse404 = {
  data: void
  status: 404
}

export type tag_deleteResponseSuccess = (tag_deleteResponse204) & {
  headers: Headers;
};
export type tag_deleteResponseError = (tag_deleteResponse404) & {
  headers: Headers;
};

export type tag_deleteResponse = (tag_deleteResponseSuccess | tag_deleteResponseError)

export const getTagDeleteUrl = (id: string,) => {




  return `/api/tag/${id}`
}

/**
 * Removes the Tag resource.
 * @summary Removes the Tag resource.
 */
export const tag_delete = async (id: string, options?: RequestInit): Promise<tag_deleteResponse> => {

  return apiCatalog<tag_deleteResponse>(getTagDeleteUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getTagDeleteMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tag_delete>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiCatalog>}
): UseMutationOptions<Awaited<ReturnType<typeof tag_delete>>, TError,{id: string}, TContext> => {

const mutationKey = ['tagDelete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof tag_delete>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  tag_delete(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TagDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof tag_delete>>>

    export type TagDeleteMutationError = void

    /**
 * @summary Removes the Tag resource.
 */
export const useTagDelete = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tag_delete>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof tag_delete>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getTagDeleteMutationOptions(options), queryClient);
    }
    export type tag_patchResponse200 = {
  data: TagJsonldTagRead
  status: 200
}

export type tag_patchResponse400 = {
  data: void
  status: 400
}

export type tag_patchResponse404 = {
  data: void
  status: 404
}

export type tag_patchResponse422 = {
  data: void
  status: 422
}

export type tag_patchResponseSuccess = (tag_patchResponse200) & {
  headers: Headers;
};
export type tag_patchResponseError = (tag_patchResponse400 | tag_patchResponse404 | tag_patchResponse422) & {
  headers: Headers;
};

export type tag_patchResponse = (tag_patchResponseSuccess | tag_patchResponseError)

export const getTagPatchUrl = (id: string,) => {




  return `/api/tag/${id}`
}

/**
 * Updates the Tag resource.
 * @summary Updates the Tag resource.
 */
export const tag_patch = async (id: string,
    tagTagWrite: TagTagWrite, options?: RequestInit): Promise<tag_patchResponse> => {

  return apiCatalog<tag_patchResponse>(getTagPatchUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/merge-patch+json', ...options?.headers },
    body: JSON.stringify(tagTagWrite)
  }
);}





export const getTagPatchMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tag_patch>>, TError,{id: string;data: TagTagWrite}, TContext>, request?: SecondParameter<typeof apiCatalog>}
): UseMutationOptions<Awaited<ReturnType<typeof tag_patch>>, TError,{id: string;data: TagTagWrite}, TContext> => {

const mutationKey = ['tagPatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof tag_patch>>, {id: string;data: TagTagWrite}> = (props) => {
          const {id,data} = props ?? {};

          return  tag_patch(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TagPatchMutationResult = NonNullable<Awaited<ReturnType<typeof tag_patch>>>
    export type TagPatchMutationBody = TagTagWrite
    export type TagPatchMutationError = void

    /**
 * @summary Updates the Tag resource.
 */
export const useTagPatch = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tag_patch>>, TError,{id: string;data: TagTagWrite}, TContext>, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof tag_patch>>,
        TError,
        {id: string;data: TagTagWrite},
        TContext
      > => {
      return useMutation(getTagPatchMutationOptions(options), queryClient);
    }
    export type get_collectionResponse200 = {
  data: GetCollection200
  status: 200
}

export type get_collectionResponseSuccess = (get_collectionResponse200) & {
  headers: Headers;
};
;

export type get_collectionResponse = (get_collectionResponseSuccess)

export const getGetCollectionUrl = (params?: GetCollectionParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["slug[]"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/tags?${stringifiedParams}` : `/api/tags`
}

/**
 * Retrieves the collection of Tag resources.
 * @summary Retrieves the collection of Tag resources.
 */
export const get_collection = async (params?: GetCollectionParams, options?: RequestInit): Promise<get_collectionResponse> => {

  return apiCatalog<get_collectionResponse>(getGetCollectionUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCollectionQueryKey = (params?: GetCollectionParams,) => {
    return [
    `/api/tags`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetCollectionQueryOptions = <TData = Awaited<ReturnType<typeof get_collection>>, TError = unknown>(params?: GetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get_collection>>, TError, TData>>, request?: SecondParameter<typeof apiCatalog>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCollectionQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof get_collection>>> = ({ signal }) => get_collection(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof get_collection>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCollectionQueryResult = NonNullable<Awaited<ReturnType<typeof get_collection>>>
export type GetCollectionQueryError = unknown


export function useGetCollection<TData = Awaited<ReturnType<typeof get_collection>>, TError = unknown>(
 params: undefined |  GetCollectionParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof get_collection>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof get_collection>>,
          TError,
          Awaited<ReturnType<typeof get_collection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCollection<TData = Awaited<ReturnType<typeof get_collection>>, TError = unknown>(
 params?: GetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get_collection>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof get_collection>>,
          TError,
          Awaited<ReturnType<typeof get_collection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCollection<TData = Awaited<ReturnType<typeof get_collection>>, TError = unknown>(
 params?: GetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get_collection>>, TError, TData>>, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves the collection of Tag resources.
 */

export function useGetCollection<TData = Awaited<ReturnType<typeof get_collection>>, TError = unknown>(
 params?: GetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get_collection>>, TError, TData>>, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCollectionQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






